export enum OrderStatus {
  New = "New",
  Confirmed = "Confirmed",
  AwaitingSampleCollection = "AwaitingSampleCollection",
  Assigned = "Assigned",
  AcceptedByPractitioner = "AcceptedByPractitioner",
  RejectedByPractitioner = "RejectedByPractitioner",
  Flagged = "Flagged",
  Started = "Started",
  Reached = "Reached",
  WithCustomer = "WithCustomer",
  NoShow = "NoShow",
  SampleCollected = "SampleCollected",
  WithLaboratory = "WithLaboratory",
  WithDispatch = "WithDispatch",
  ResultUploaded = "ResultUploaded",
  Cancelled = "Cancelled",
  KitDelivered = "KitDelivered",
  AwaitingKitCollection = "AwaitingKitCollection",
  AwaitingKitDropOff = "AwaitingKitDropOff",
  KitCollected = "KitCollected",
  VaccineAdministered = "VaccineAdministered",
  Completed = "Completed",
  ResultAvailable="ResultAvailable"
}
